import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { isBoolean } from "lodash";
import { useNotify } from "react-admin";
import { handleAxiosError } from "../../../common/data/axiosErrorHandler";
import { TenantApiFactory, TenantRegistrationDto } from "../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";

interface Props {
    label: string;
    icon: JSX.Element;
    record?: TenantRegistrationDto;
    resource?: string;
    hidden?: boolean | ((record: TenantRegistrationDto) => boolean);
}

export const ExportDriversDataMenuItem = ({
    record,
    hidden,
    label,
    icon,
    ...rest
}: Props) => {
    const axios = useAxiosInstance();
    const notify = useNotify();
    const createdTenantId = record?.createdTenantId?.trim();

    if (!record?.id || !createdTenantId) {
        return null;
    }

    if (isBoolean(hidden)) {
        if (hidden) {
            return null;
        }
    } else {
        if (hidden && hidden(record)) {
            return null;
        }
    }

    const handleExportDriversData = async () => {
        if (!axios) {
            return Promise.reject("Unable to resolve the axios instance");
        }

        if (!createdTenantId) {
            return Promise.reject("Created tenant ID is required");
        }

        try {
            const result = await TenantApiFactory(
                undefined,
                axios.defaults.baseURL,
                axios
            ).apiMultiTenancyTenantsExportPost(createdTenantId, {
                responseType: "blob",
                headers: {
                    Accept: "text/csv, application/octet-stream",
                    "X-Requested-With": undefined,
                },
            });

            const contentDisposition = result.headers?.["content-disposition"];
            const fileNameMatch = contentDisposition?.match(/filename\*?=(?:UTF-8''|")?([^";\n]+)/i);
            const fileName = decodeURIComponent(
                fileNameMatch?.[1]?.replace(/"/g, "") ?? "tenant-drivers-export.csv"
            );
            const blob = result.data as unknown as Blob;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (e) {
            console.error(e);
            notify(handleAxiosError(e), { type: "error" });
        }
    };

    return (
        <MenuItem
            {...rest}
            className="actions-menu-item"
            onClick={handleExportDriversData}
        >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText>{label}</ListItemText>
        </MenuItem>
    );
};
